import { useEffect, useRef, useState } from 'react';
import type { KeyboardEvent } from 'react';
import { Icon, rovingKey } from '@platform/ui';
import type { IDesignCreateMenuProps } from './IDesignCreateMenuProps';

/**
 * «+ Створити ▾» списку проєктування з кількома видами записів (прототип v4 baNewMenu: «Мотивація · Усі» — Проблема, Ризик, Можливість):
 * акцентна кнопка панелі відкриває меню видів (220px, рядки 32px); вибір створює запис цього виду. Клавіатура: ↑ ↓ Home End між видами,
 * Esc закриває й повертає фокус на кнопку; клік поза меню закриває його.
 */
export function DesignCreateMenu({ label, menuLabel, items }: IDesignCreateMenuProps) {
  const [open, setOpen] = useState(false);
  const button = useRef<HTMLButtonElement>(null);
  const menu = useRef<HTMLDivElement>(null);
  const entries = () => [...(menu.current?.querySelectorAll<HTMLButtonElement>('[role="menuitem"]') ?? [])];
  useEffect(() => { if (open) entries()[0]?.focus(); }, [open]);
  const close = () => { setOpen(false); button.current?.focus(); };
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Escape' || e.key === 'Tab') { e.preventDefault(); close(); return; }
    const list = entries();
    const next = rovingKey(e.key, list.indexOf(document.activeElement as HTMLButtonElement), list.length);
    if (next === null) return;
    e.preventDefault();
    list[next]?.focus();
  };
  return (
    <div className="dsg-create">
      <button ref={button} type="button" className="lv-create dsg-create__btn" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        {label}<Icon name="chevron-down" size={14} />
      </button>
      {open && (
        <>
          <div className="dsg-create__overlay" aria-hidden="true" onClick={() => setOpen(false)} />
          <div ref={menu} role="menu" aria-label={menuLabel} className="dsg-create__menu" onKeyDown={onKeyDown}>
            {items.map((it) => (
              <button key={it.key} type="button" role="menuitem" className="dsg-create__item" onClick={() => { setOpen(false); it.onSelect(); }}>{it.label}</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
